/**
 * Prod-stripped chaos probe for customer L2/L3 error-isolation E2E.
 *
 * Pure gates live in errorIsolationProbeLogic.ts (Jest-safe; no import.meta).
 * Activation: window __RPAPP_E2E_THROW__ via Playwright addInitScript only.
 */

export {
  ERROR_ISOLATION_PROBE_FEATURES,
  isErrorIsolationProbeFeature,
  resolveErrorIsolationProbeThrow,
  type ErrorIsolationProbeFeature,
  type ErrorIsolationProbeProps,
} from './errorIsolationProbeLogic.js';

import {
  resolveErrorIsolationProbeThrow,
  type ErrorIsolationProbeProps,
} from './errorIsolationProbeLogic.js';

/**
 * Tiny render probe: reads window.__RPAPP_E2E_THROW__ once; throws if it
 * matches this mount's feature under the DEV / flag gate.
 */
export function ErrorIsolationProbe(props: ErrorIsolationProbeProps): null {
  const { feature: mountFeature } = props;

  if (import.meta.env.PROD) {
    if (
      typeof window === 'undefined' ||
      window.__RPAPP_E2E_THROW__ === undefined
    ) {
      return null;
    }
  }

  const flag =
    typeof window !== 'undefined' ? window.__RPAPP_E2E_THROW__ : undefined;

  const feature = resolveErrorIsolationProbeThrow({
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
    flag,
    mountFeature,
  });

  if (feature !== null) {
    throw new Error('[rpapp-e2e] errorIsolationProbe throw feature=' + feature);
  }

  return null;
}